<div
  class="relative max-w-[500px] mb-2 py-4 px-8 bg-tertiary border border-primary border-b-4 border-b-corporate-400 rounded text-primary pointer-events-auto">
  <h4 class="text-base md:text-lg">{{'notifications.title.' + message | transloco}}</h4>
  <p class="mt-2 text-xs md:text-sm">{{'notifications.body.' + message | transloco}}</p>
  <button class="close" (click)="remove()"></button>
  <div class="mt-5">
    <app-button [title]="'notifications.open' | transloco" (click)="goTo()"></app-button>
  </div>
</div>
